import { useMemo } from "react";

import { PointOfContact } from "@/components/players/ContactChart/Top/PointOfContact";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { cn } from "@/lib/utils";

type Coordinate = {
  xFeet: number;
  yFeet: number;
  pitchType?: string;
  result?: string;
  className?: string;
};

type ContactData = {
  coordinates: Coordinate[];
};

type ContactPointCardProps = {
  title: string;
  data: ContactData[];
} & React.ComponentProps<typeof Card>;

export const ContactPointCard = ({
  title,
  data = [],
  ...rest
}: ContactPointCardProps) => {
  const coordinates = useMemo(
    () =>
      data.flatMap((d) =>
        d.coordinates.map((coord) => ({
          ...coord,
          pitchType: coord.pitchType || "defaultType",
          result: coord.result || "defaultResult",
        })),
      ),
    [data],
  );

  return (
    <Card {...rest} className={cn("w-full p-1 flex flex-col", rest.className)}>
      <CardHeader className="p-2">
        <CardTitle className="text-xs md:text-sm text-center">
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent className="overflow-hidden flex-1">
        <Separator className="mb-2" />
        <div className="w-full h-full relative">
          <PointOfContact coordinates={coordinates} />
        </div>
      </CardContent>
    </Card>
  );
};
